import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../../t2c-fe/utils';

interface Payload {
  prompt: string;
}

const generateAndSaveAiText = async (payload: Payload): Promise<string> => {
  const res = await axiosInstance.post('/api/script/generate-ai-script', payload);
  return res.data;
};
export const useGenerateAndSaveAiText = () => {
  return useMutation(generateAndSaveAiText, { onSuccess: (data) => data });
};
